import React from "react";
import shoopingCard from "../../../assets/img/shopping_cart.svg";
import calendarIcon from "../../../assets/img/calendar.svg";
import NumberFormat from "react-number-format";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

export function WidgetsIconCards(props) {
  return (
    <div
      className={`card col-12 col-lg-${props.sizeLG} p-4 ${
        (props.className !== undefined) & (props.className !== null) ? props.className : ""
      }`}
    >
      <img
        className="title"
        src={props.typeIcon === "calendar" ? calendarIcon : shoopingCard}
        alt=""
        width={24}
        height={24}
      />
      <span className="text-cl-black-2 ff-roboto-medium fz-10 uppercase ">{props.title}</span>
      {props.children}
    </div>
  );
}

export function WidgetsArrowNumber(props) {
  const formattedValue = () => {
    if (props.isFloat) {
      return !Number.isInteger(props.value) ? props.value.toFixed(2) : parseFloat(props.value).toFixed(2);
    } else {
      return props.value;
    }
  };
  // console.log(Number.isInteger(props.value), props.value);
  return (
    <>
      <span className="d-flex align-items-center ff-univanova-bold fz-24 text-cl-black-2 mt-1">
        <NumberFormat
          style={props.style}
          thousandSeparator={","}
          decimalSeparator="."
          displayType={"text"}
          prefix={props.isCurrency ? "R$ " : ""}
          value={formattedValue()}
        />
        <div
          style={{ borderRadius: "50%", width: "24px", height: "24px" }}
          className={`d-flex ms-2 justify-content-center align-items-center bg-cl-bright-gray`}
        >
          <FontAwesomeIcon icon={faArrowUp} className={`text-cl-green rotate-icon fz-14`} />
        </div>
        <span className="text-cl-green ff-roboto fw-bold fz-12 ms-2">{`${
          isNaN(props.statics) ? `0` : props.statics === "Infinity" ? `+100` : `+${props.statics}`
        } %`}</span>
      </span>
      <span className="text-cl-arsenic ff-univanova fz-12 mt-1">
        {`${props.description}`}
        <NumberFormat
          style={props.style}
          thousandSeparator={","}
          decimalSeparator="."
          displayType={"text"}
          prefix={props.isCurrency ? "R$ " : ""}
          value={props.descriptionValue}
        />
        {")"}
      </span>
    </>
  );
}
